import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import { cookie } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitleAd from './newsTitleAd';
import Tabs from './tabs';
import TabPane from './tabPane';
import ContentList from './contentlist';
import ExtraList from './extraList';
import NewsList from '../../../../../components/newsList';

class NewsTop extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    handleAreaArr = () => {
        const {
            content: { newsTitle },
        } = this.props;

        try {
            let prov = null;
            let city = null;

            if (typeof document !== 'undefined') {
                prov =
                    cookie.get('prov') && cookie.get('prov') !== '' && cookie.get('prov') !== 'cn010'
                        ? cookie.get('prov')
                        : null;
                city =
                    cookie.get('city') && cookie.get('city') !== '' && cookie.get('city') !== '010'
                        ? cookie.get('city')
                        : null;
            }

            let localKey = '';
            let lastOneKey = '';

            if (prov && city) {
                let arr = newsTitle.filter(item => item.city === city);

                if (arr.length === 0) {
                    arr = newsTitle.filter(item => item.prov === prov).filter(item => item.prov === `cn${item.city}`);
                }

                if (arr.length > 0) {
                    arr = arr[0];

                    localKey = arr.localKey;
                    lastOneKey = arr.lastOneKey;
                }

                return {
                    arr,
                    localKey,
                    lastOneKey,
                };
            }

            return {
                arr: [],
                localKey,
                lastOneKey,
            };
        } catch (e) {
            console.error(e);

            return {
                arr: [],
                localKey: '',
                lastOneKey: '',
            };
        }
    };

    render() {
        const {
            content: { newsTitle, newsTitleAd, newContent, newsListAd },
        } = this.props;
        let tabs = [newsTitle[0]];
        let localKey = '';
        let lastOneKey = '';

        const areaData = this.handleAreaArr();

        if (areaData) {
            tabs = [newsTitle[0], areaData.arr ? areaData.arr : []];
            localKey = areaData.localKey ? areaData.localKey : '';
            lastOneKey = areaData.lastOneKey ? areaData.lastOneKey : '';
        }

        const info = {
            id: localKey,
            type: 'static',
            title: '要闻区中栏地方站要闻列表',
            groupName: '要闻区中栏',
            position: 'relative',
        };

        const lastInfo = {
            id: lastOneKey,
            type: 'static',
            title: '要闻区中栏地方站要闻列表最后一条',
            groupName: '要闻区中栏',
            position: 'relative',
        };

        return (
            <div className={styles.news_top}>
                <Chip
                    id="75129"
                    type="recommend"
                    title="要闻区中栏标题推广"
                    groupName="要闻区中栏"
                    content={newsTitleAd}>
                    <NewsTitleAd />
                </Chip>
                <Tabs newsTitle={newsTitle} tabs={tabs}>
                    {tabs.map((item, index) => (
                        <TabPane key={index} tab={item.title} url={item.url}>
                            {index === 0 ? (
                                <ContentList content={newContent} />
                            ) : (
                                <NoSSR>
                                    <ExtraList localKey={localKey} info={info} />
                                </NoSSR>
                            )}
                        </TabPane>
                    ))}
                </Tabs>
                {lastOneKey ? (
                    <NoSSR>
                        <ExtraList localKey={lastOneKey} info={lastInfo} />
                    </NoSSR>
                ) : (
                    <Chip
                        id="75030"
                        type="recommend"
                        title="要闻区中栏要闻列表最后一条"
                        groupName="要闻区中栏"
                        translate="handleNewsContentData"
                        position="relative"
                        content={newContent.newsContent3}>
                        <NewsList ad={newsListAd} />
                    </Chip>
                )}
            </div>
        );
    }
}

export default errorBoundary(NewsTop);
